import Vue from 'vue'
import Router from 'vue-router'
import Main from '../components/Main'
import Home from "../components/Home";
import Login from "../components/Login";
import Tabs from "../components/Tabs";
import cookie from "../service/cookie";

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const vueRouter = new Router({
  mode:'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children:[
      	  {path:'/home',component:Home,name:'home' ,meta: {requireAuth: true,}},   //首页
          {path:'/:url',component:Tabs,name:'tabs' ,meta: {requireAuth: true,}},   //渲染页面

      ]
    },
    {path: '*', redirect: '/login'}
  ]
});
vueRouter.beforeEach((to, from, next) => {
  if (to.matched.some((r) => r.meta.requireAuth)) {
    let user = cookie.getCookie('access_token_ul_wf');
    if (user) {   //判断是否已经登录
      next();
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}   //登录成功后重定向到当前页面
      });
    }
  } else {
    next();
  }
  //如果本地 存在 token 则 不允许直接跳转到 登录页面
  if(to.fullPath === "/login"){
    if(cookie.getCookie('access_token_ul_wf')){
      next({
        path:from.fullPath
      });
    }else {
      next();
    }
  }
});

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js